import React, { useState, useEffect } from 'react';

// CustomPicker component for the web version
const CustomPicker = ({ options, selectedValue, onValueChange, style }) => {
  return (
    <select
      value={selectedValue}
      onChange={(e) => onValueChange(e.target.value)}
      style={{
        padding: '0.5rem',
        borderRadius: '10px',
        border: '1px solid #e5e7eb',
        backgroundColor: 'white',
        color: '#333',
        ...style
      }}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

const RecurrenceField = ({ frequency, period, onFrequencyChange, onPeriodChange }) => {
  const recurrenceTypes = [
    { value: 'days', label: 'day(s)' },
    { value: 'weeks', label: 'week(s)' },
    { value: 'months', label: 'month(s)' },
    { value: 'years', label: 'year(s)' },
  ];

  const [recurrenceType, setRecurrenceType] = useState('none');
  const [displayFrequency, setDisplayFrequency] = useState('1');

  useEffect(() => {
    // Initialize recurrence type based on period
    setRecurrenceType(period === 'none' ? 'none' : 'every');
    
    // Initialize display frequency with the actual frequency value
    if (frequency === 'none') {
      setDisplayFrequency('1');
    } else if (frequency) {
      setDisplayFrequency(String(frequency));
    }
  }, [frequency, period]);

  const toggleRecurrenceType = () => {
    const newType = recurrenceType === 'none' ? 'every' : 'none';
    setRecurrenceType(newType);
    if (newType === 'none') {
      setDisplayFrequency('1');
      onFrequencyChange('none');
      onPeriodChange('none');
    } else {
      onFrequencyChange(displayFrequency);
      onPeriodChange('months');
    }
  };

  const handleFrequencyChange = (value) => {
    // Update the display value
    setDisplayFrequency(value);
    
    // If the value is empty or invalid
    if (!value || value.trim() === '') {
      onFrequencyChange(null);
      return;
    }
    
    // Only allow positive numbers
    const parsed = parseInt(value);
    if (!isNaN(parsed) && parsed > 0) {
      onFrequencyChange(parsed);
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '1rem',
    }}>
      <label style={{ 
        fontWeight: 'bold',
        flex: 1
      }}>
        Recurrence
      </label>
      <div style={{
        flex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}>
        <button
          type="button"
          onClick={toggleRecurrenceType}
          style={{
            padding: '0.5rem',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: '#e5e7eb',
            borderRadius: '10px',
            justifyContent: 'center',
            minWidth: '60px',
            textAlign: 'center',
            backgroundColor: 'transparent',
            cursor: 'pointer',
          }}
        >
          {recurrenceType === 'none' ? 'None' : 'Every'}
        </button>
        {recurrenceType === 'every' && (
          <>
            <input
              type="text"
              style={{
                width: '40px',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
                textAlign: 'center',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#e5e7eb',
                borderRadius: '10px',
                padding: '0.5rem',
                color: '#333',
              }}
              value={displayFrequency}
              onChange={(e) => handleFrequencyChange(e.target.value)}
              maxLength={2}
              placeholder="1"
            />
            <div style={{ flex: 1, marginLeft: '0.25rem' }}>
              <CustomPicker
                options={recurrenceTypes}
                selectedValue={period === 'none' ? 'months' : period}
                onValueChange={onPeriodChange}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RecurrenceField;